<template>
    <v-list>
        <v-subheader>Lists ({{ value.length }})</v-subheader>
        <v-btn text small @click="$emit('create')" class="mb-8">Create a list</v-btn>
        <v-list-item v-for="(item, index) in value" :value="item" :key="item.id" dense>
            <v-btn block plain small @click="menuClick(index)" class="px-0">
                <div class="text-subtitle-2 text-capitalize">
                    {{ name(item) }}
                </div>
                <v-spacer></v-spacer>
                <div class="caption">
                    {{ item.private ? 'private' : 'public' }}
                </div>
            </v-btn>
        </v-list-item>
    </v-list>
</template>
<style scoped></style>
<script>
import {} from '@mdi/js';

export default {
    name: 'BnftWishlistList',
    props: {
        value: Array,
    },
    components: {},
    methods: {
        name: (item) => item?.name || item.id,
        menuClick(index) {
            this.$emit('change', index);
        },
    },
    data: function () {
        return {};
    },
    mounted() {},
};
</script>
